// export const BASE_URL = 'https://api-sme.promixaccounting.com/api/v1';
export const BASE_URL = 'https://api.ogunstate.gov.ng/api';
